module.exports = __webpack_public_path__ + "electro.png?cef27d7eef2e6998fc1c2953838806b6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/electro.png
// module id = 962
// module chunks = 2